/* eslint-disable jsdoc/require-returns-description */
/**
 * Global user preferences for non-React utility functions.
 * This file exists to break circular dependencies between utility.jsx
 * and UserPreferencesContext.jsx.
 */

let globalUserPreferences = {
  timezone: 'UTC',
  mapStyle: 'light',
  locale: 'en_US',
  customColumnWidth: {},
}

const listeners = new Set()

/**
 * Updates the global preferences object.
 * @param {object} preferences - New preferences to merge.
 */
export const setUserPreferencesGlobal = (preferences) => {
  globalUserPreferences = { ...globalUserPreferences, ...preferences }
  listeners.forEach((listener) => {
    try {
      listener()
    } catch (error) {
      console.error('Error notifying user preferences listener:', error)
    }
  })
}

/**
 * Returns the current global preferences.
 * @returns {object}
 */
export const getUserPreferencesGlobal = () => globalUserPreferences

export const subscribeUserPreferencesGlobal = (listener) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
